// LEGACY COMPATIBILITY FILE - ALL VAPID/OneSignal CODE DISABLED
// This file only provides stub functions for backward compatibility
// All notification functionality now uses Firebase FCM in fcmService.js

console.warn('[oneSignal.js] DEPRECATED: Using compatibility stubs. Please migrate to fcmService.js');

// Stub functions for backward compatibility
export const isPushNotificationSupported = () => 'Notification' in window;
export const registerServiceWorker = async () => null;
export const requestNotificationPermission = async () => Notification.permission;
export const subscribeToPushNotifications = async () => null;
export const unsubscribeFromPushNotifications = async () => false;
export const isPushSubscribed = async () => Notification.permission === 'granted';
export const getPushSubscription = async () => null;

// Aliases
export const isNotificationSupported = isPushNotificationSupported;
export const isUserSubscribed = () => Notification.permission === 'granted';
export const subscribeToNotifications = async () => {
  console.warn('[oneSignal DEPRECATED] Please use enableNotifications from fcmService.js');
  return false;
};

// Helper functions
export const isFirstTimeUser = () => { try { return !localStorage.getItem('notificationPromptShown'); } catch { return true; } };
export const markPromptShown = () => { try { localStorage.setItem('notificationPromptShown', 'true'); } catch {} };
export const getNotificationPermission = () => typeof Notification !== 'undefined' ? Notification.permission : 'default';
export const isStandaloneMode = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

